import React, { Component } from 'react';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import Tab from 'react-bootstrap/Tab';
import LoadingIndicator from 'components/LoadingIndicator';
import SafeMarkdown from 'components/SafeMarkdown';
import TabView from 'components/TabView';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import { toSlug } from 'utils/strings';
import withMediaQuery from 'utils/withMediaQuery';
import './FaqContent.css';

class FaqContent extends Component {
  generateContent(faqSections) {
    const tabTitles = faqSections.map((i, idx) => ({
      title: i.name,
      key: toSlug(i.name)
    }));

    const tabPanes = faqSections.map((i, idx) => {
      return (
        <Tab.Pane
          eventKey={toSlug(i.name)}
          key={idx}
          mountOnEnter
          unmountOnExit
        >
          <h2 className="sr-only">{i.name}</h2>
          <SafeMarkdown source={i.content} />
        </Tab.Pane>
      );
    });

    return (
      <TabView
        tabTitles={tabTitles}
        className="dark-nav"
        id="faq-tab-content"
        matchesBreakpoint={this.props.matchesBreakpoint}
      >
        <Tab.Content>{tabPanes}</Tab.Content>
      </TabView>
    );
  }

  render() {
    const {
      data: { faqSections, loading, error }
    } = this.props;

    let content;
    if (loading) {
      content = <LoadingIndicator expand />;
    } else if (error || !faqSections) {
      content = (
        <div className="error-message">
          <p>An error occured accessing the FAQs.</p>
        </div>
      );
    } else {
      content = this.generateContent(faqSections);
    }

    return <div className="faq-content">{content}</div>;
  }
}

export default compose(
  withMediaQuery(LG_BREAKPOINT_AND_UP),
  graphql(gql`
    query GetFaq {
      faqSections {
        name
        content
      }
    }
  `)
)(FaqContent);
